import React, { useEffect, useRef } from "react";
import "./DetalisProject.css";
import { useLocation } from "react-router-dom";
import Logo from "../../image/1Ysr-R03-0VI-Logo (1).png";
import SA181 from "../../image/SA181/1Ysr-R03-003-Media-SA181-فلوريت (2).jpg";
import { Link } from "react-router-dom";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

const DetalisProject = () => {
  const refb = useRef();
  const location = useLocation();
  console.log(location.state.data);
  useEffect(() => {
    window.scrollTo(100, 0);
  }, [location.state]);
  return (
    <div className="DetalisProject">
      <div className="DetalisProject-Header">
        <img src={<Skeleton width={40} height={40} count={10} /> ||Logo} alt="" />
        <button
          ref={refb}
          onClick={() => {
            window.history.back();
          }}
        >
          <i class="bx bxs-left-arrow"></i>رجوع
        </button>
        {/* <Link to="/">
          <i class="bx bxs-left-arrow"></i>رجوع
        </Link> */}
      </div>
      <div className="Definition-Body">
        <img
          src={
            location.state === null ? (
              <Skeleton count={10} />
            ) : (
              location.state.data.image
            )
          }
          alt=""
        />
        <p>
          {location.state === null ? (
            <Skeleton count={10} />
          ) : (
            location.state.data.title
          )}
        </p>
      </div>
      <div className="Definition-content">
        <div className="content-left content">
          <img
            src={
              location.state === null ? (
                <Skeleton count={10} />
              ) : (
                location.state.data.DetalisProjectimage5
              )
            }
            alt=""
          />
          <div className="content-left-text content-text">
            <h2>معلومات المشروع</h2>
            <p>
              الموقع :
              <label>
                {location.state === null ? (
                  <Skeleton count={10} />
                ) : (
                  location.state.data.site
                )}
              </label>
            </p>
            <p>
              مما تتألف :
              <label>
                {location.state === null ? (
                  <Skeleton count={10} />
                ) : (
                  location.state.data.Composed
                )}
              </label>
            </p>
          </div>
        </div>
        <div className="content-right content">
          <img
            src={
              location.state === null ? (
                <Skeleton count={10} />
              ) : (
                location.state.data.DetalisProjectimage2
              )
            }
            alt=""
          />
          <div className="content-left-text content-text">
            <h2>ميزات المشروع</h2>
            <p
              style={{
                color: "var(--body-color)",
                fontSize: "20px",
                whiteSpace: "pre-line",
              }}
            >
              ​
              {location.state === null ? (
                <Skeleton count={10} />
              ) : (
                location.state.data.Marked_by
              )}
            </p>
          </div>
        </div>
        <div className="content-left content">
          <img
            src={
              location.state === null ? (
                <Skeleton count={10} />
              ) : (
                location.state.data.DetalisProjectimage5
              )
            }
            alt=""
          />
          <div className="content-left-text content-text">
            <h2>تفاصيل المشروع</h2>
            <p style={{ color: "var(--body-color)", fontSize: "20px" }}>
              {location.state === null ? (
                <Skeleton count={10} />
              ) : (
                location.state.data.Consists_of
              )}
            </p>
          </div>
        </div>
        <div className="content-right content">
          <img
            src={
              location.state === null ? (
                <Skeleton count={10} />
              ) : (
                location.state.data.DetalisProjectimage2
              )
            }
            alt=""
          />
          <div className="content-left-text content-text">
            <h2>بعض خدمات المشروع</h2>
            <p
              style={{
                color: "var(--body-color)",
                fontSize: "20px",
                whiteSpace: "pre-line",
              }}
            >
              {location.state === null ? (
                <Skeleton count={10} />
              ) : (
                location.state.data.Services
              )}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DetalisProject;
